
import '../../css/chart.css'
import '../../css/chart-info.css'
import { useEffect, useRef, useState } from "react"
import { NewForm } from "./new-form"
import { PedroForm } from "./pedro-form"
import { Chart } from "../../components/chart"
import { Button } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import { BiChart } from '../../components/bi-chart'
import { ChartB } from '../../components/chartB'
import dayjs, { Dayjs } from 'dayjs';
import { FieldSectionType, FieldSelectedSections } from '@mui/x-date-pickers';
import { ChartDayArrow } from '../../components/chart-day-arrow'
import WheelInputChart from '../../components/wheel-input-chart'
import { ChartMonthArrow } from '../../components/chart-month-arrow'
import { ChartYearArrow } from '../../components/chart-year-arrow'




interface ChartSummaryProps{
    id: string,
    name: string;
    utc: string;
    utc_formatted: string;
    local_formatted: string;
    location: string;
    chart_type: string;
    wheel_type: string;
    lat: string;
    long: string;
    lat_formatted: string;
    long_formatted: string;
    timezone: string;
    natal_date: string;
   

}

interface SolarReturnSummaryProps{
    utc: string;
    utc_formatted: string;
    local: string;
    location: string;
    solar_return: string;
    solar_date: string;
}



export const NewChart = () => {

    const [ isVisible, setIsVisible] = useState(true)
    const [newForm, setNewForm] = useState(true)
    const [editForm, setEditForm] = useState(false)
    const[display, setDisplay] = useState({natal: false, solar_return: false, biwheel: false, sidebyside: false})
    const [wheelDisplay, setWheelDisplay] = useState(false)
    const [hideWheel, setHideWheel] = useState(false)
    const hideTime = useMediaQuery('(max-width:540px)') && wheelDisplay;;

    const displayRef = useRef({
       natal:false, biwheel:false, sidebyside:false})
    
    const ptid = useRef('')

    const [ wheelType, setWheelType] = useState('')

    const [defaultDate, setDefaultDate] = useState<Dayjs | null>(dayjs(null));

    const [allowedToFetch, setAllowedToFetch] = useState(true)
    
    const tid = useRef('')
    
    const lat =  useRef('')
    
    const long = useRef('')

    const timezone = useRef('')
      
    let dayCount = useRef(0)

    const [chartSummary, setChartSummary] = useState({
        id:'',
        name: '',
        utc: '',
        utc_formatted: '',
        local_formatted: '',
        location: '',
        chart_type: '',
        wheel_type: '',
        lat_formatted: '',
        long_formatted: '',
        lat: '',
        long: '',
        timezone: '',
        natal_date: ''
    })
    
    const [solarReturnSummary, setSolarReturnSummary] = useState({
        utc: '',
        utc_formatted: '',
        local: '',
        location: '',
        solar_return: '',
        solar_date: ''

    })


    const getSuccess = (success: boolean) => { 
  
        
    }

    const getSuccessCustom = (success: boolean) => { 
        
        
    }

    const formRef = useRef<HTMLFormElement>(null);
    // const showRef = useRef(false)

    const handleVisible = () => {
        setEditForm(true)
        setNewForm(true)
        setDisplay({natal: false, solar_return: false,  biwheel: false, sidebyside: false})
        setWheelDisplay(false)
        setHideWheel(false)
      };

    const handleWheel = () => {
        setWheelDisplay(true)
    }

    const getDateInput = (date:Dayjs | undefined) => { 
        if(date !== undefined){
            //setDefaultDate(date)
            //varTid = date.utc().format()
            console.log(date.utc().format())
        }
        
    }
    
    const [selectedSections, setSelectedSections] =
    useState<FieldSelectedSections>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const setSelectedSectionType = (selectedSectionType: FieldSectionType) => {
    inputRef.current?.focus();
    setSelectedSections(selectedSectionType);
    };

    const getChartSummary = (chartSummary: ChartSummaryProps) => {
        setChartSummary(chartSummary)
    
    }
   

    const getSolarReturnSummary = (solarReturnSummary: SolarReturnSummaryProps) => {
        setSolarReturnSummary(solarReturnSummary)
    }

    const [DegreeSym, setDegreeSym] = useState('°')
    const [DegreeBSym, setDegreeBSym] = useState('°')

    const [RXSym, setRXSym] = useState('M')
    const [RXBSym, setRXBSym] = useState('M')

    const[signVals, setSignVals] = useState({
        AriSignX : '-7',
        AriSignY : '604',
        TauSignX : '121',
        TauSignY : '828',
        GemSignX : '345',
        GemSignY : '957',
        CanSignX : '604',
        CanSignY : '957',
        LeoSignX : '828',
        LeoSignY : '828',
        VirSignX : '957',
        VirSignY : '604',
        LibSignX : '957',
        LibSignY : '345',
        ScoSignX : '828',
        ScoSignY : '121',
        SagSignX : '604',
        SagSignY : '-7',
        CapSignX : '345',
        CapSignY : '-7',
        AquSignX : '121',
        AquSignY : '121',
        PisSignX : '-7',
        PisSignY : '345'
    })

    const[signBVals, setSignBVals] = useState({
        AriBSignX : '-7',
        AriBSignY : '604',
        TauBSignX : '121',
        TauBSignY : '828',
        GemBSignX : '345',
        GemBSignY : '957',
        CanBSignX : '604',
        CanBSignY : '957',
        LeoBSignX : '828',
        LeoBSignY : '828',
        VirBSignX : '957',
        VirBSignY : '604',
        LibBSignX : '957',
        LibBSignY : '345',
        ScoBSignX : '828',
        ScoBSignY : '121',
        SagBSignX : '604',
        SagBSignY : '-7',
        CapBSignX : '345',
        CapBSignY : '-7',
        AquBSignX : '121',
        AquBSignY : '121',
        PisBSignX : '-7',
        PisBSignY : '345'
    })

    const [moVals, setMoVals] = useState({
        MoSym:"",
        MoPlanetX: "",
        MoPlanetY: "",
        MoSign: "",
        MoSignSym: "",
        MoSignX: "",
        MoSignY: "",
        MoDegree: "",
        MoDegreeX: "",
        MoDegreeY: "",
        MoMinute: "",
        MoMinuteX: "",
        MoMinuteY: ""

        })

        const [moBVals, setMoBVals] = useState({
            MoBSym:"",
            MoBPlanetX: "",
            MoBPlanetY: "",
            MoBSign: "",
            MoBSignSym: "",
            MoBSignX: "",
            MoBSignY: "",
            MoBDegree: "",
            MoBDegreeX: "",
            MoBDegreeY: "",
            MoBMinute: "",
            MoBMinuteX: "",
            MoBMinuteY: "",
    
        })

    const [meVals, setMeVals] = useState({
        MeSym:"",
        MePlanetX: "",
        MePlanetY: "",
        MeSign: "",
        MeSignSym: "",
        MeSignX: "",
        MeSignY: "",
        MeDegree: "",
        MeDegreeX: "",
        MeDegreeY: "",
        MeMinute: "",
        MeMinuteX: "",
        MeMinuteY: "",
        MeRX: true,
        MeRXX: "",
        MeRXY: ""
        
        })

        const [meBVals, setMeBVals] = useState({
           
            MeBSym:"",
            MeBPlanetX: "",
            MeBPlanetY: "",
            MeBSign: "",
            MeBSignSym: "",
            MeBSignX: "",
            MeBSignY: "",
            MeBDegree: "",
            MeBDegreeX: "",
            MeBDegreeY: "",
            MeBMinute: "",
            MeBMinuteX: "",
            MeBMinuteY: "",
            MeBRX: true,
            MeBRXX: "",
            MeBRXY: "",
            
        })

    const [veVals, setVeVals] = useState({
        VeSym:"",
        VePlanetX: "",
        VePlanetY: "",
        VeSign: "",
        VeSignSym: "",
        VeSignX: "",
        VeSignY: "",
        VeDegree: "",
        VeDegreeX: "",
        VeDegreeY: "",
        VeMinute: "",
        VeMinuteX: "",
        VeMinuteY: "",
        VeRX: false,
        VeRXX: "",
        VeRXY: ""
    })

    const [veBVals, setVeBVals] = useState({
       
        VeBSym:"",
        VeBPlanetX: "",
        VeBPlanetY: "",
        VeBSign: "",
        VeBSignSym: "",
        VeBSignX: "",
        VeBSignY: "",
        VeBDegree: "",
        VeBDegreeX: "",
        VeBDegreeY: "",
        VeBMinute: "",
        VeBMinuteX: "",
        VeBMinuteY: "",
        VeBRX: false,
        VeBRXX: "",
        VeBRXY: ""
    })

    const [suVals, setSuVals] = useState({
        SuSym:"",
        SuPlanetX: "",
        SuPlanetY: "",
        SuSign: "",
        SuSignSym: "",
        SuSignX: "",
        SuSignY: "",
        SuDegree: "",
        SuDegreeX: "",
        SuDegreeY: "",
        SuMinute: "",
        SuMinuteX: "",
        SuMinuteY: "",
        SuRX: "",
        SuRY: ""
    })

    const [suBVals, setSuBVals] = useState({
       
        SuBSym:"",
        SuBPlanetX: "",
        SuBPlanetY: "",
        SuBSign: "",
        SuBSignSym: "",
        SuBSignX: "",
        SuBSignY: "",
        SuBDegree: "",
        SuBDegreeX: "",
        SuBDegreeY: "",
        SuBMinute: "",
        SuBMinuteX: "",
        SuBMinuteY: "",
        SuBRX: "",
        SuBRY: ""
    })

    const [maVals, setMaVals] = useState({
        MaSym:"",
        MaPlanetX: "",
        MaPlanetY: "",
        MaSign: "",
        MaSignSym: "",
        MaSignX: "",
        MaSignY: "",
        MaDegree: "",
        MaDegreeX: "",
        MaDegreeY: "",
        MaMinute: "",
        MaMinuteX: "",
        MaMinuteY: "",
        MaRX: false,
        MaRXX: "",
        MaRXY: ""
    })

    const [maBVals, setMaBVals] = useState({
       
        MaBSym:"",
        MaBPlanetX: "",
        MaBPlanetY: "",
        MaBSign: "",
        MaBSignSym: "",
        MaBSignX: "",
        MaBSignY: "",
        MaBDegree: "",
        MaBDegreeX: "",
        MaBDegreeY: "",
        MaBMinute: "",
        MaBMinuteX: "",
        MaBMinuteY: "",
        MaBRX: false,
        MaBRXX: "",
        MaBRXY: ""
    })

    const [juVals, setJuVals] = useState({
        JuSym:"",
        JuPlanetX: "",
        JuPlanetY: "",
        JuSign: "",
        JuSignSym: "",
        JuSignX: "",
        JuSignY: "",
        JuDegree: "",
        JuDegreeX: "",
        JuDegreeY: "",
        JuMinute: "",
        JuMinuteX: "",
        JuMinuteY: "",
        JuRX: false,
        JuRXX: "",
        JuRXY: ""
    })

    const [juBVals, setJuBVals] = useState({
       
        JuBSym:"",
        JuBPlanetX: "",
        JuBPlanetY: "",
        JuBSign: "",
        JuBSignSym: "",
        JuBSignX: "",
        JuBSignY: "",
        JuBDegree: "",
        JuBDegreeX: "",
        JuBDegreeY: "",
        JuBMinute: "",
        JuBMinuteX: "",
        JuBMinuteY: "",
        JuBRX: false,
        JuBRXX: "",
        JuBRXY: ""
    })

    const [saVals, setSaVals] = useState({
        SaSym:"",
        SaPlanetX: "",
        SaPlanetY: "",
        SaSign: "",
        SaSignSym: "",
        SaSignX: "",
        SaSignY: "",
        SaDegree: "",
        SaDegreeX: "",
        SaDegreeY: "",
        SaMinute: "",
        SaMinuteX: "",
        SaMinuteY: "",
        SaRX: false,
        SaRXX: "",
        SaRXY: ""
    })

    const [saBVals, setSaBVals] = useState({
       
        SaBSym:"",
        SaBPlanetX: "",
        SaBPlanetY: "",
        SaBSign: "",
        SaBSignSym: "",
        SaBSignX: "",
        SaBSignY: "",
        SaBDegree: "",
        SaBDegreeX: "",
        SaBDegreeY: "",
        SaBMinute: "",
        SaBMinuteX: "",
        SaBMinuteY: "",
        SaBRX: false,
        SaBRXX: "",
        SaBRXY: ""
    })

    const [urVals, setUrVals] = useState({
        UrSym:"",
        UrPlanetX: "",
        UrPlanetY: "",
        UrSign: "",
        UrSignSym: "",
        UrSignX: "",
        UrSignY: "",
        UrDegree: "",
        UrDegreeX: "",
        UrDegreeY: "",
        UrMinute: "",
        UrMinuteX: "",
        UrMinuteY: "",
        UrRX: false,
        UrRXX: "",
        UrRXY: ""
    })

    const [urBVals, setUrBVals] = useState({
        
        UrBSym:"",
        UrBPlanetX: "",
        UrBPlanetY: "",
        UrBSign: "",
        UrBSignSym: "",
        UrBSignX: "",
        UrBSignY: "",
        UrBDegree: "",
        UrBDegreeX: "",
        UrBDegreeY: "",
        UrBMinute: "",
        UrBMinuteX: "",
        UrBMinuteY: "",
        UrBRX: false,
        UrBRXX: "",
        UrBRXY: ""
    })

    const [neVals, setNeVals] = useState({
        NeSym:"",
        NePlanetX: "",
        NePlanetY: "",
        NeSign: "",
        NeSignSym: "",
        NeSignX: "",
        NeSignY: "",
        NeDegree: "",
        NeDegreeX: "",
        NeDegreeY: "",
        NeMinute: "",
        NeMinuteX: "",
        NeMinuteY: "",
        NeRX: false,
        NeRXX: "",
        NeRXY: ""
    })

    const [neBVals, setNeBVals] = useState({
       
        NeBSym:"",
        NeBPlanetX: "",
        NeBPlanetY: "",
        NeBSign: "",
        NeBSignSym: "",
        NeBSignX: "",
        NeBSignY: "",
        NeBDegree: "",
        NeBDegreeX: "",
        NeBDegreeY: "",
        NeBMinute: "",
        NeBMinuteX: "",
        NeBMinuteY: "",
        NeBRX: false,
        NeBRXX: "",
        NeBRXY: ""
    })

    const [plVals, setPlVals] = useState({
        PlSym:"",
        PlPlanetX: "",
        PlPlanetY: "",
        PlSign: "",
        PlSignSym: "",
        PlSignX: "",
        PlSignY: "",
        PlDegree: "",
        PlDegreeX: "",
        PlDegreeY: "",
        PlMinute: "",
        PlMinuteX: "",
        PlMinuteY: "",
        PlRX: false,
        PlRXX: "",
        PlRXY: ""
    })

    const [plBVals, setPlBVals] = useState({
       
        PlBSym:"",
        PlBPlanetX: "",
        PlBPlanetY: "",
        PlBSign: "",
        PlBSignSym: "",
        PlBSignX: "",
        PlBSignY: "",
        PlBDegree: "",
        PlBDegreeX: "",
        PlBDegreeY: "",
        PlBMinute: "",
        PlBMinuteX: "",
        PlBMinuteY: "",
        PlBRX: false,
        PlBRXX: "",
        PlBRXY: ""
    })

    const [raVals, setRaVals] = useState({
        RaSym:"",
        RaPlanetX: "",
        RaPlanetY: "",
        RaSign: "",
        RaSignSym: "",
        RaSignX: "",
        RaSignY: "",
        RaDegree: "",
        RaDegreeX: "",
        RaDegreeY: "",
        RaMinute: "",
        RaMinuteX: "",
        RaMinuteY: "",
        RaRX: true,
        RaRXX: "",
        RaRXY: "",
        RXSym: ""
    })

    const [raBVals, setRaBVals] = useState({
       
        RaBSym:"",
        RaBPlanetX: "",
        RaBPlanetY: "",
        RaBSign: "",
        RaBSignSym: "",
        RaBSignX: "",
        RaBSignY: "",
        RaBDegree: "",
        RaBDegreeX: "",
        RaBDegreeY: "",
        RaBMinute: "",
        RaBMinuteX: "",
        RaBMinuteY: "",
        RaBRX: true,
        RaBRXX: "",
        RaBRXY: "",
        RXBSym: ""
    })

    const [keVals, setKeVals] = useState({
        KeSym:"",
        KePlanetX: "",
        KePlanetY: "",
        KeSign: "",
        KeSignSym: "",
        KeSignX: "",
        KeSignY: "",
        KeDegree: "",
        KeDegreeX: "",
        KeDegreeY: "",
        KeMinute: "",
        KeMinuteX: "",
        KeMinuteY: "",
        KeRX:  true,
        KeRXX: "",
        KeRXY: ""
    })

    const [keBVals, setKeBVals] = useState({
       
        KeBSym:"",
        KeBPlanetX: "",
        KeBPlanetY: "",
        KeBSign: "",
        KeBSignSym: "",
        KeBSignX: "",
        KeBSignY: "",
        KeBDegree: "",
        KeBDegreeX: "",
        KeBDegreeY: "",
        KeBMinute: "",
        KeBMinuteX: "",
        KeBMinuteY: "",
        KeBRX:  true,
        KeBRXX: "",
        KeBRXY: ""
    })

    const [chVals, setChVals] = useState({
        ChSym:"",
        ChPlanetX: "",
        ChPlanetY: "",
        ChSign: "",
        ChSignSym: "",
        ChSignX: "",
        ChSignY: "",
        ChDegree: "",
        ChDegreeX: "",
        ChDegreeY: "",
        ChMinute: "",
        ChMinuteX: "",
        ChMinuteY: "",
        ChRX:false,
        ChRXX: "",
        ChRXY: ""
    })

    const [chBVals, setChBVals] = useState({
       
        ChBSym:"",
        ChBPlanetX: "",
        ChBPlanetY: "",
        ChBSign: "",
        ChBSignSym: "",
        ChBSignX: "",
        ChBSignY: "",
        ChBDegree: "",
        ChBDegreeX: "",
        ChBDegreeY: "",
        ChBMinute: "",
        ChBMinuteX: "",
        ChBMinuteY: "",
        ChBRX:false,
        ChBRXX: "",
        ChBRXY: ""
    })

    const [ascVals, setASCVals] = useState({
        ASCSym:"",
        ASCPlanetX: "",
        ASCPlanetY: "",
        ASCSign: "",
        ASCSignSym: "",
        ASCSignX: "",
        ASCSignY: "",
        ASCDegree: "",
        ASCDegreeX: "",
        ASCDegreeY: "",
        ASCMinute: "",
        ASCMinuteX: "",
        ASCMinuteY: ""

    })

    const [ascBVals, setASCBVals] = useState({
       
        ASCBSym:"",
        ASCBPlanetX: "",
        ASCBPlanetY: "",
        ASCBSign: "",
        ASCBSignSym: "",
        ASCBSignX: "",
        ASCBSignY: "",
        ASCBDegree: "",
        ASCBDegreeX: "",
        ASCBDegreeY: "",
        ASCBMinute: "",
        ASCBMinuteX: "",
        ASCBMinuteY: "",

    })
       const [dscVals, setDSCVals] = useState({
        DSCSym:"",
        DSCPlanetX: "",
        DSCPlanetY: "",
        DSCSign: "",
        DSCSignSym: "",
        DSCSignX: "",
        DSCSignY: "",
        DSCDegree: "",
        DSCDegreeX: "",
        DSCDegreeY: "",
        DSCMinute: "",
        DSCMinuteX: "",
        DSCMinuteY: ""
    })

    const [dscBVals, setDSCBVals] = useState({
    
        DSCBSym:"",
        DSCBPlanetX: "",
        DSCBPlanetY: "",
        DSCBSign: "",
        DSCBSignSym: "",
        DSCBSignX: "",
        DSCBSignY: "",
        DSCBDegree: "",
        DSCBDegreeX: "",
        DSCBDegreeY: "",
        DSCBMinute: "",
        DSCBMinuteX: "",
        DSCBMinuteY: "",

    })

    const [icVals, setICVals] = useState({
        ICSym:"",
        ICPlanetX: "",
        ICPlanetY: "",
        ICSign: "",
        ICSignSym: "",
        ICSignX: "",
        ICSignY: "",
        ICDegree: "",
        ICDegreeX: "",
        ICDegreeY: "",
        ICMinute: "",
        ICMinuteX: "",
        ICMinuteY: ""

    })

    const [icBVals, setICBVals] = useState({
       
        ICBSym:"",
        ICBPlanetX: "",
        ICBPlanetY: "",
        ICBSign: "",
        ICBSignSym: "",
        ICBSignX: "",
        ICBSignY: "",
        ICBDegree: "",
        ICBDegreeX: "",
        ICBDegreeY: "",
        ICBMinute: "",
        ICBMinuteX: "",
        ICBMinuteY: "",

    })

    const [mcVals, setMCVals] = useState({
        MCSym:"",
        MCPlanetX: "",
        MCPlanetY: "",
        MCSign: "",
        MCSignSym: "",
        MCSignX: "",
        MCSignY: "",
        MCDegree: "",
        MCDegreeX: "",
        MCDegreeY: "",
        MCMinute: "",
        MCMinuteX: "",
        MCMinuteY: ""
    })

    const [mcBVals, setMCBVals] = useState({
       
        MCBSym:"",
        MCBPlanetX: "",
        MCBPlanetY: "",
        MCBSign: "",
        MCBSignSym: "",
        MCBSignX: "",
        MCBSignY: "",
        MCBDegree: "",
        MCBDegreeX: "",
        MCBDegreeY: "",
        MCBMinute: "",
        MCBMinuteX: "",
        MCBMinuteY: "",
    })

    const [lofoVals, setLoFoVals] = useState({
        LoFoSym:"",
        LoFoPlanetX: "",
        LoFoPlanetY: "",
        LoFoSign: "",
        LoFoSignSym: "",
        LoFoSignX: "",
        LoFoSignY: "",
        LoFoDegree: "",
        LoFoDegreeX: "",
        LoFoDegreeY: "",
        LoFoMinute: "",
        LoFoMinuteX: "",
        LoFoMinuteY: ""
    })

    const [lofoBVals, setLoFoBVals] = useState({
        LoFoBSym:"",
        LoFoBPlanetX: "",
        LoFoBPlanetY: "",
        LoFoBSign: "",
        LoFoBSignSym: "",
        LoFoBSignX: "",
        LoFoBSignY: "",
        LoFoBDegree: "",
        LoFoBDegreeX: "",
        LoFoBDegreeY: "",
        LoFoBMinute: "",
        LoFoBMinuteX: "",
        LoFoBMinuteY: ""
    })

    console.log(displayRef.current)
    console.log(chartSummary.long_formatted, chartSummary.lat_formatted)
    console.log(chartSummary.name)
    console.log(wheelType)
    console.log("Latitude",lat.current, long.current)

    return (
        <>
    {/* { isVisible &&  */}
    <div style={{ display: newForm ? 'flex' : 'none' }} className="form-container">
         
        <NewForm ref={formRef} 
        // showRef={showRef}
           moVals={moVals} setMoVals={setMoVals} 
           meVals={meVals} setMeVals={setMeVals} 
           veVals={veVals} setVeVals={setVeVals} 
           suVals={suVals} setSuVals={setSuVals} 
           setMaVals={setMaVals} maVals={maVals}
           setJuVals={setJuVals} juVals={juVals}
           setSaVals={setSaVals} saVals={saVals}  
           setUrVals={setUrVals} urVals={urVals}
           setNeVals={setNeVals} neVals={neVals}   
           setPlVals={setPlVals} plVals={plVals}
           setRaVals={setRaVals} raVals={raVals}  
           setKeVals={setKeVals} keVals={keVals}  
           setChVals={setChVals} chVals={chVals}  
           setASCVals={setASCVals} ascVals={ascVals} 
           setDSCVals={setDSCVals} dscVals={dscVals} 
           setICVals={setICVals} icVals={icVals} 
           setMCVals={setMCVals} mcVals={mcVals}
           setLoFoVals={setLoFoVals} lofoVals={lofoVals}
           setSignVals={setSignVals} signVals={signVals}
           moBVals={moBVals} setMoBVals={setMoBVals} 
           meBVals={meBVals} setMeBVals={setMeBVals} 
           veBVals={veBVals} setVeBVals={setVeBVals} 
           suBVals={suBVals} setSuBVals={setSuBVals} 
           setMaBVals={setMaBVals} maBVals={maBVals}
           setJuBVals={setJuBVals} juBVals={juBVals}
           setSaBVals={setSaBVals} saBVals={saBVals}  
           setUrBVals={setUrBVals} urBVals={urBVals}
           setNeBVals={setNeBVals} neBVals={neBVals}   
           setPlBVals={setPlBVals} plBVals={plBVals}
           setRaBVals={setRaBVals} raBVals={raBVals}  
           setKeBVals={setKeBVals} keBVals={keBVals}  
           setChBVals={setChBVals} chBVals={chBVals}  
           setASCBVals={setASCBVals} ascBVals={ascBVals} 
           setDSCBVals={setDSCBVals} dscBVals={dscBVals} 
           setICBVals={setICBVals} icBVals={icBVals} 
           setMCBVals={setMCBVals} mcBVals={mcBVals}
           setLoFoBVals={setLoFoBVals} lofoBVals={lofoBVals}
           setSignBVals={setSignBVals} signBVals={signBVals}
           setDegreeSym={setDegreeSym}  DegreeSym={DegreeSym}
           getSuccess={getSuccess} getChartSummary={getChartSummary}
           getSuccessCustom={getSuccessCustom}
           getSolarReturnSummary={getSolarReturnSummary}
           defaultDate={defaultDate} setDefaultDate={setDefaultDate}
           setDisplay={setDisplay} display={display} displayRef={displayRef}
           setNewForm ={setNewForm} editForm={editForm} setEditForm={setEditForm}
           setIsVisible={setIsVisible} ptid={ptid} lat={lat} long={long} timezone={timezone}
           wheelType={wheelType} setWheelType={setWheelType}
           wheelDisplay={wheelDisplay} setWheelDisplay={setWheelDisplay}
           
       />
      </div>

       
    {!newForm &&
    <div className="chart-view">

        {hideTime && !wheelDisplay &&<Button 
        onClick ={handleWheel}
        variant="text">Move Wheel</Button>
        }
        {hideTime && wheelDisplay &&
        <Button 
        onClick ={() => {setWheelDisplay(false)}}
        variant="text">Hide Wheel</Button>}

        <div className="chart-info">
        {/* style={{ display: natalDisplay ? 'flex' : 'none' }} */}

      {!hideTime &&
       <div className="natal chart-summary libre-franklin-chart">
        {chartSummary.name}<br />
        {chartSummary.local_formatted}<br />
        {chartSummary.utc_formatted} <em>(GMT)</em> <br />
        {chartSummary.location}<br />
        Long {chartSummary.long_formatted}  Lat {chartSummary.lat_formatted}<br />
        
        <Button 
        onClick ={handleVisible}
        variant="text">Edit Chart</Button>
        {display.natal && !wheelDisplay &&
        <Button 
        onClick ={() => { if(!hideWheel){handleWheel()}else{setWheelDisplay(true)}
            }}
        variant="text">Move Wheel</Button>}
        {display.natal && wheelDisplay &&
        <Button 
        onClick ={() => {setHideWheel(true); setWheelDisplay(false)}}
        variant="text">Hide Wheel</Button>}
        
        
        </div>}
    
        {/* <div style={{ width: display.biwheel && !wheelDisplay ? '9%' : '0%' }}></div> */}
        <div className="side-by-side-spacer" style={{ width: display.sidebyside && !wheelDisplay  ? '25%' : '0%' }}></div>

        {!display.natal && !hideTime &&
        <div className="solar-return chart-summary libre-franklin-chart">
        {solarReturnSummary.solar_return} Solar Return<br />
        {solarReturnSummary.local}<br />
        {solarReturnSummary.utc_formatted} <em>(GMT)</em> <br />
        {solarReturnSummary.location}<br />
        {/* Ref place:  */}
        {!wheelDisplay &&<Button 
        onClick ={handleWheel}
        variant="text">Move Wheel</Button>
        }
        {wheelDisplay &&
        <Button 
        onClick ={() => {setWheelDisplay(false)}}
        variant="text">Hide Wheel</Button>}
        </div>
        }
        <div className='arrow-controls' style={{ display: wheelDisplay ? 'flex' : 'none' }}>
        {/* <div className='arrow-back-group-sm' >
       
        </div> */}
        
        <WheelInputChart
        moVals={moVals} setMoVals={setMoVals} 
        meVals={meVals} setMeVals={setMeVals} 
        veVals={veVals} setVeVals={setVeVals} 
        suVals={suVals} setSuVals={setSuVals} 
        setMaVals={setMaVals} maVals={maVals}
        setJuVals={setJuVals} juVals={juVals}
        setSaVals={setSaVals} saVals={saVals}  
        setUrVals={setUrVals} urVals={urVals}
        setNeVals={setNeVals} neVals={neVals}   
        setPlVals={setPlVals} plVals={plVals}
        setRaVals={setRaVals} raVals={raVals}  
        setKeVals={setKeVals} keVals={keVals}  
        setChVals={setChVals} chVals={chVals}  
        setASCVals={setASCVals} ascVals={ascVals} 
        setDSCVals={setDSCVals} dscVals={dscVals} 
        setICVals={setICVals} icVals={icVals} 
        setMCVals={setMCVals} mcVals={mcVals}
        setLoFoVals={setLoFoVals} lofoVals={lofoVals}
        setSignVals={setSignVals} signVals={signVals}
        moBVals={moBVals} setMoBVals={setMoBVals} 
        meBVals={meBVals} setMeBVals={setMeBVals} 
        veBVals={veBVals} setVeBVals={setVeBVals} 
        suBVals={suBVals} setSuBVals={setSuBVals} 
        setMaBVals={setMaBVals} maBVals={maBVals}
        setJuBVals={setJuBVals} juBVals={juBVals}
        setSaBVals={setSaBVals} saBVals={saBVals}  
        setUrBVals={setUrBVals} urBVals={urBVals}
        setNeBVals={setNeBVals} neBVals={neBVals}   
        setPlBVals={setPlBVals} plBVals={plBVals}
        setRaBVals={setRaBVals} raBVals={raBVals}  
        setKeBVals={setKeBVals} keBVals={keBVals}  
        setChBVals={setChBVals} chBVals={chBVals}  
        setASCBVals={setASCBVals} ascBVals={ascBVals} 
        setDSCBVals={setDSCBVals} dscBVals={dscBVals} 
        setICBVals={setICBVals} icBVals={icBVals} 
        setMCBVals={setMCBVals} mcBVals={mcBVals}
        setLoFoBVals={setLoFoBVals} lofoBVals={lofoBVals}
        setSignBVals={setSignBVals} signBVals={signBVals}
        setDegreeSym={setDegreeSym}  DegreeSym={DegreeSym}
        RXSym={RXSym} setRXSym={setRXSym}
        setDegreeBSym={setDegreeBSym}  DegreeBSym={DegreeBSym}
        RXBSym={RXBSym} setRXBSym={setRXBSym}
        lat={lat} long={long} timezone={timezone} ptid={ptid}
        defaultDate={defaultDate} setDefaultDate={setDefaultDate}
        setAllowedToFetch={setAllowedToFetch}
        setSelectedSectionType={setSelectedSectionType} selectedSections={selectedSections} 
        inputRef={inputRef}
        wheelType={wheelType} setWheelType={setWheelType}
        />
       

        <div className='arrow-forward-group-sm'>
            <ChartDayArrow
            moVals={moVals} setMoVals={setMoVals}  
            meVals={meVals} setMeVals={setMeVals} 
            veVals={veVals} setVeVals={setVeVals} 
            suVals={suVals} setSuVals={setSuVals} 
            setMaVals={setMaVals} maVals={maVals}
            setJuVals={setJuVals} juVals={juVals}
            setSaVals={setSaVals} saVals={saVals}  
            setUrVals={setUrVals} urVals={urVals}
            setNeVals={setNeVals} neVals={neVals}   
            setPlVals={setPlVals} plVals={plVals}
            setRaVals={setRaVals} raVals={raVals}  
            setKeVals={setKeVals} keVals={keVals}  
            setChVals={setChVals} chVals={chVals}  
            setASCVals={setASCVals} ascVals={ascVals} 
            setDSCVals={setDSCVals} dscVals={dscVals} 
            setICVals={setICVals} icVals={icVals} 
            setMCVals={setMCVals} mcVals={mcVals}
            setLoFoVals={setLoFoVals} lofoVals={lofoVals}
            setSignVals={setSignVals} signVals={signVals}
            moBVals={moBVals} setMoBVals={setMoBVals} 
            meBVals={meBVals} setMeBVals={setMeBVals} 
            veBVals={veBVals} setVeBVals={setVeBVals} 
            suBVals={suBVals} setSuBVals={setSuBVals} 
            setMaBVals={setMaBVals} maBVals={maBVals}
            setJuBVals={setJuBVals} juBVals={juBVals}
            setSaBVals={setSaBVals} saBVals={saBVals}  
            setUrBVals={setUrBVals} urBVals={urBVals}
            setNeBVals={setNeBVals} neBVals={neBVals}   
            setPlBVals={setPlBVals} plBVals={plBVals}
            setRaBVals={setRaBVals} raBVals={raBVals}  
            setKeBVals={setKeBVals} keBVals={keBVals}  
            setChBVals={setChBVals} chBVals={chBVals}  
            setASCBVals={setASCBVals} ascBVals={ascBVals} 
            setDSCBVals={setDSCBVals} dscBVals={dscBVals} 
            setICBVals={setICBVals} icBVals={icBVals} 
            setMCBVals={setMCBVals} mcBVals={mcBVals}
            setLoFoBVals={setLoFoBVals} lofoBVals={lofoBVals}
            setSignBVals={setSignBVals} signBVals={signBVals}
            setDegreeSym={setDegreeSym}  DegreeSym={DegreeSym}
            RXSym={RXSym} setRXSym={setRXSym}
            setDegreeBSym={setDegreeBSym}  DegreeBSym={DegreeBSym}
            RXBSym={RXBSym} setRXBSym={setRXBSym}
            tid={tid} lat={lat} long={long} timezone={timezone}
            ptid={ptid}
            allowedToFetch={allowedToFetch} setAllowedToFetch={setAllowedToFetch}
            dayCount={dayCount} 
            setDefaultDate={setDefaultDate} defaultDate={defaultDate}
            setSelectedSectionType={setSelectedSectionType} 
            selectedSections={selectedSections} 
            inputRef={inputRef}
            wheelType={wheelType} setWheelType={setWheelType}
        />
      
            <ChartMonthArrow
            moVals={moVals} setMoVals={setMoVals}  
            meVals={meVals} setMeVals={setMeVals} 
            veVals={veVals} setVeVals={setVeVals} 
            suVals={suVals} setSuVals={setSuVals} 
            setMaVals={setMaVals} maVals={maVals}
            setJuVals={setJuVals} juVals={juVals}
            setSaVals={setSaVals} saVals={saVals}  
            setUrVals={setUrVals} urVals={urVals}
            setNeVals={setNeVals} neVals={neVals}   
            setPlVals={setPlVals} plVals={plVals}
            setRaVals={setRaVals} raVals={raVals}  
            setKeVals={setKeVals} keVals={keVals}  
            setChVals={setChVals} chVals={chVals}  
            setASCVals={setASCVals} ascVals={ascVals} 
            setDSCVals={setDSCVals} dscVals={dscVals} 
            setICVals={setICVals} icVals={icVals} 
            setMCVals={setMCVals} mcVals={mcVals}
            setLoFoVals={setLoFoVals} lofoVals={lofoVals}
            setSignVals={setSignVals} signVals={signVals}
            moBVals={moBVals} setMoBVals={setMoBVals} 
            meBVals={meBVals} setMeBVals={setMeBVals} 
            veBVals={veBVals} setVeBVals={setVeBVals} 
            suBVals={suBVals} setSuBVals={setSuBVals} 
            setMaBVals={setMaBVals} maBVals={maBVals}
            setJuBVals={setJuBVals} juBVals={juBVals}
            setSaBVals={setSaBVals} saBVals={saBVals}  
            setUrBVals={setUrBVals} urBVals={urBVals}
            setNeBVals={setNeBVals} neBVals={neBVals}   
            setPlBVals={setPlBVals} plBVals={plBVals}
            setRaBVals={setRaBVals} raBVals={raBVals}  
            setKeBVals={setKeBVals} keBVals={keBVals}  
            setChBVals={setChBVals} chBVals={chBVals}  
            setASCBVals={setASCBVals} ascBVals={ascBVals} 
            setDSCBVals={setDSCBVals} dscBVals={dscBVals} 
            setICBVals={setICBVals} icBVals={icBVals} 
            setMCBVals={setMCBVals} mcBVals={mcBVals}
            setLoFoBVals={setLoFoBVals} lofoBVals={lofoBVals}
            setSignBVals={setSignBVals} signBVals={signBVals}
            setDegreeSym={setDegreeSym}  DegreeSym={DegreeSym}
            RXSym={RXSym} setRXSym={setRXSym}
            setDegreeBSym={setDegreeBSym}  DegreeBSym={DegreeBSym}
            RXBSym={RXBSym} setRXBSym={setRXBSym}
            tid={tid} lat={lat} long={long} timezone={timezone}
            ptid={ptid}
            allowedToFetch={allowedToFetch} setAllowedToFetch={setAllowedToFetch}
            dayCount={dayCount} 
            setDefaultDate={setDefaultDate} defaultDate={defaultDate}
            setSelectedSectionType={setSelectedSectionType} 
            selectedSections={selectedSections} 
            inputRef={inputRef}
            wheelType={wheelType} setWheelType={setWheelType}
        />
        
            <ChartYearArrow
            moVals={moVals} setMoVals={setMoVals}  
            meVals={meVals} setMeVals={setMeVals} 
            veVals={veVals} setVeVals={setVeVals} 
            suVals={suVals} setSuVals={setSuVals} 
            setMaVals={setMaVals} maVals={maVals}
            setJuVals={setJuVals} juVals={juVals}
            setSaVals={setSaVals} saVals={saVals}  
            setUrVals={setUrVals} urVals={urVals}
            setNeVals={setNeVals} neVals={neVals}   
            setPlVals={setPlVals} plVals={plVals}
            setRaVals={setRaVals} raVals={raVals}  
            setKeVals={setKeVals} keVals={keVals}  
            setChVals={setChVals} chVals={chVals}  
            setASCVals={setASCVals} ascVals={ascVals} 
            setDSCVals={setDSCVals} dscVals={dscVals} 
            setICVals={setICVals} icVals={icVals} 
            setMCVals={setMCVals} mcVals={mcVals}
            setLoFoVals={setLoFoVals} lofoVals={lofoVals}
            setSignVals={setSignVals} signVals={signVals}
            moBVals={moBVals} setMoBVals={setMoBVals} 
            meBVals={meBVals} setMeBVals={setMeBVals} 
            veBVals={veBVals} setVeBVals={setVeBVals} 
            suBVals={suBVals} setSuBVals={setSuBVals} 
            setMaBVals={setMaBVals} maBVals={maBVals}
            setJuBVals={setJuBVals} juBVals={juBVals}
            setSaBVals={setSaBVals} saBVals={saBVals}  
            setUrBVals={setUrBVals} urBVals={urBVals}
            setNeBVals={setNeBVals} neBVals={neBVals}   
            setPlBVals={setPlBVals} plBVals={plBVals}
            setRaBVals={setRaBVals} raBVals={raBVals}  
            setKeBVals={setKeBVals} keBVals={keBVals}  
            setChBVals={setChBVals} chBVals={chBVals}  
            setASCBVals={setASCBVals} ascBVals={ascBVals} 
            setDSCBVals={setDSCBVals} dscBVals={dscBVals} 
            setICBVals={setICBVals} icBVals={icBVals} 
            setMCBVals={setMCBVals} mcBVals={mcBVals}
            setLoFoBVals={setLoFoBVals} lofoBVals={lofoBVals}
            setSignBVals={setSignBVals} signBVals={signBVals}
            setDegreeSym={setDegreeSym}  DegreeSym={DegreeSym}
            RXSym={RXSym} setRXSym={setRXSym}
            setDegreeBSym={setDegreeBSym}  DegreeBSym={DegreeBSym}
            RXBSym={RXBSym} setRXBSym={setRXBSym}
            tid={tid} lat={lat} long={long} timezone={timezone}
            ptid={ptid}
            allowedToFetch={allowedToFetch} setAllowedToFetch={setAllowedToFetch}
            dayCount={dayCount} 
            setDefaultDate={setDefaultDate} defaultDate={defaultDate}
            setSelectedSectionType={setSelectedSectionType} 
            selectedSections={selectedSections} 
            inputRef={inputRef}
            wheelType={wheelType} setWheelType={setWheelType}
        />
        </div>
        </div>
        
        </div>
        
        {!newForm &&
        <div  className="chart-container">
         {/* <div style={{ display: display.natal ? 'block' : 'none' }}> */}
        {!display.biwheel &&
    
        <Chart className={`${display.sidebyside ? 'side-by-side-a' : 'chart'}`}
            moVals={moVals} setMoVals={setMoVals}  
            meVals={meVals} setMeVals={setMeVals} 
            veVals={veVals} setVeVals={setVeVals} 
            suVals={suVals} setSuVals={setSuVals} 
            setMaVals={setMaVals} maVals={maVals}
            setJuVals={setJuVals} juVals={juVals}
            setSaVals={setSaVals} saVals={saVals}  
            setUrVals={setUrVals} urVals={urVals}
            setNeVals={setNeVals} neVals={neVals}   
            setPlVals={setPlVals} plVals={plVals}
            setRaVals={setRaVals} raVals={raVals}  
            setKeVals={setKeVals} keVals={keVals}  
            setChVals={setChVals} chVals={chVals}  
            setASCVals={setASCVals} ascVals={ascVals} 
            setDSCVals={setDSCVals} dscVals={dscVals} 
            setICVals={setICVals} icVals={icVals} 
            setMCVals={setMCVals} mcVals={mcVals} 
            setLoFoVals={setLoFoVals} lofoVals={lofoVals} 
            setSignVals={setSignVals} signVals={signVals}
            moBVals={moBVals} setMoBVals={setMoBVals} 
            meBVals={meBVals} setMeBVals={setMeBVals} 
            veBVals={veBVals} setVeBVals={setVeBVals} 
            suBVals={suBVals} setSuBVals={setSuBVals} 
            setMaBVals={setMaBVals} maBVals={maBVals}
            setJuBVals={setJuBVals} juBVals={juBVals}
            setSaBVals={setSaBVals} saBVals={saBVals}  
            setUrBVals={setUrBVals} urBVals={urBVals}
            setNeBVals={setNeBVals} neBVals={neBVals}   
            setPlBVals={setPlBVals} plBVals={plBVals}
            setRaBVals={setRaBVals} raBVals={raBVals}  
            setKeBVals={setKeBVals} keBVals={keBVals}  
            setChBVals={setChBVals} chBVals={chBVals}  
            setASCBVals={setASCBVals} ascBVals={ascBVals} 
            setDSCBVals={setDSCBVals} dscBVals={dscBVals} 
            setICBVals={setICBVals} icBVals={icBVals} 
            setMCBVals={setMCBVals} mcBVals={mcBVals}
            setLoFoBVals={setLoFoBVals} lofoBVals={lofoBVals}
            setSignBVals={setSignBVals} signBVals={signBVals}
            setDegreeSym={setDegreeSym}  DegreeSym={DegreeSym}
            defaultDate={defaultDate} setDefaultDate={setDefaultDate}
            
            
            />
           
            }
            {display.sidebyside&&
            <ChartB className={`${display.sidebyside ? 'side-by-side-b' : 'chart'}`}
        // className={`chart ${display.sidebyside ? 'side-by-side' : ''}`}
                moVals={moVals} setMoVals={setMoVals}  
                meVals={meVals} setMeVals={setMeVals} 
                veVals={veVals} setVeVals={setVeVals} 
                suVals={suVals} setSuVals={setSuVals} 
                setMaVals={setMaVals} maVals={maVals}
                setJuVals={setJuVals} juVals={juVals}
                setSaVals={setSaVals} saVals={saVals}  
                setUrVals={setUrVals} urVals={urVals}
                setNeVals={setNeVals} neVals={neVals}   
                setPlVals={setPlVals} plVals={plVals}
                setRaVals={setRaVals} raVals={raVals}  
                setKeVals={setKeVals} keVals={keVals}  
                setChVals={setChVals} chVals={chVals}  
                setASCVals={setASCVals} ascVals={ascVals} 
                setDSCVals={setDSCVals} dscVals={dscVals} 
                setICVals={setICVals} icVals={icVals} 
                setMCVals={setMCVals} mcVals={mcVals}
                setLoFoVals={setLoFoVals} lofoVals={lofoVals}
                setSignVals={setSignVals} signVals={signVals}
                moBVals={moBVals} setMoBVals={setMoBVals} 
                meBVals={meBVals} setMeBVals={setMeBVals} 
                veBVals={veBVals} setVeBVals={setVeBVals} 
                suBVals={suBVals} setSuBVals={setSuBVals} 
                setMaBVals={setMaBVals} maBVals={maBVals}
                setJuBVals={setJuBVals} juBVals={juBVals}
                setSaBVals={setSaBVals} saBVals={saBVals}  
                setUrBVals={setUrBVals} urBVals={urBVals}
                setNeBVals={setNeBVals} neBVals={neBVals}   
                setPlBVals={setPlBVals} plBVals={plBVals}
                setRaBVals={setRaBVals} raBVals={raBVals}  
                setKeBVals={setKeBVals} keBVals={keBVals}  
                setChBVals={setChBVals} chBVals={chBVals}  
                setASCBVals={setASCBVals} ascBVals={ascBVals} 
                setDSCBVals={setDSCBVals} dscBVals={dscBVals} 
                setICBVals={setICBVals} icBVals={icBVals} 
                setMCBVals={setMCBVals} mcBVals={mcBVals}
                setLoFoBVals={setLoFoBVals} lofoBVals={lofoBVals}
                setSignBVals={setSignBVals} signBVals={signBVals}
                setDegreeBSym={setDegreeBSym}  DegreeBSym={DegreeBSym}
                RXBSym={RXBSym} setRXBSym={setRXBSym}
                defaultDate={defaultDate} setDefaultDate={setDefaultDate}
            
            
            />
            }
            </div> } 
    
    {/* } */}
    {/* </div> */}

    {display.biwheel&&
    <div className='bichart-container' >
    {/* style={{ display: biwheelDisplay ? 'block' : 'none' }} */}
        <BiChart 
            moVals={moVals} setMoVals={setMoVals}  
            meVals={meVals} setMeVals={setMeVals} 
            veVals={veVals} setVeVals={setVeVals} 
            suVals={suVals} setSuVals={setSuVals} 
            setMaVals={setMaVals} maVals={maVals}
            setJuVals={setJuVals} juVals={juVals}
            setSaVals={setSaVals} saVals={saVals}  
            setUrVals={setUrVals} urVals={urVals}
            setNeVals={setNeVals} neVals={neVals}   
            setPlVals={setPlVals} plVals={plVals}
            setRaVals={setRaVals} raVals={raVals}  
            setKeVals={setKeVals} keVals={keVals}  
            setChVals={setChVals} chVals={chVals}  
            setASCVals={setASCVals} ascVals={ascVals} 
            setDSCVals={setDSCVals} dscVals={dscVals} 
            setICVals={setICVals} icVals={icVals} 
            setMCVals={setMCVals} mcVals={mcVals}
            setLoFoVals={setLoFoVals} lofoVals={lofoVals}
            setSignVals={setSignVals} signVals={signVals}
            moBVals={moBVals} setMoBVals={setMoBVals} 
            meBVals={meBVals} setMeBVals={setMeBVals} 
            veBVals={veBVals} setVeBVals={setVeBVals} 
            suBVals={suBVals} setSuBVals={setSuBVals} 
            setMaBVals={setMaBVals} maBVals={maBVals}
            setJuBVals={setJuBVals} juBVals={juBVals}
            setSaBVals={setSaBVals} saBVals={saBVals}  
            setUrBVals={setUrBVals} urBVals={urBVals}
            setNeBVals={setNeBVals} neBVals={neBVals}   
            setPlBVals={setPlBVals} plBVals={plBVals}
            setRaBVals={setRaBVals} raBVals={raBVals}  
            setKeBVals={setKeBVals} keBVals={keBVals}  
            setChBVals={setChBVals} chBVals={chBVals}  
            setASCBVals={setASCBVals} ascBVals={ascBVals} 
            setDSCBVals={setDSCBVals} dscBVals={dscBVals} 
            setICBVals={setICBVals} icBVals={icBVals} 
            setMCBVals={setMCBVals} mcBVals={mcBVals}
            setLoFoBVals={setLoFoBVals} lofoBVals={lofoBVals}
            setDegreeSym={setDegreeSym}  DegreeSym={DegreeSym}
            RXSym={RXSym} setRXSym={setRXSym}
            defaultDate={defaultDate} setDefaultDate={setDefaultDate}
        
        />
    </div>
    }
    </div> }
    

    </>
    
    )
  
}